import React from 'react';

import ken_classroom from '../../content/images/ken-classroom.jpg';
import ken_office from '../../content/images/ken-office.jpg';

function Story() {

    return (
        <React.Fragment>
            <link rel="stylesheet" type="text/css" href="/styles/about.css" />

            {/* <h1>About Great&nbsp;Leaps</h1>

            <div class="row">
                <div class="offset-md-1 col-md-4">
                    <p class="story-slogan">We envision a world where <b>all students</b> are given the opportunity to achieve their potential. <b>EXPECT MORE!</b></p>
                </div>

                <div class="offset-md-2 col-md-4">
                    <p class="story-slogan">Our mission is to <b>equip all students</b> for success through <b>simple</b> and <b>effective</b> educational programs.</p>
                </div>
            </div> */}

            <div class="about-title-image-w">
                <h1 class="about-title-main remove-underline">Our Story</h1>
                <h4 id="ourstory-subheading">Our mission is to <strong>equip all students</strong> for success through <strong>simple</strong> and <strong>effective</strong> educational programs.</h4>
            </div>

            <div id="ourstory-content">
                <h2 class="section-header text-left">History</h2>

                <div class="row">
                    <div class="col-md-8 text-justify vcenter">
                        <p class="indented">Success breeds success and necessity is the mother of invention. The story of Great Leaps’ international success starts like so many, with humble beginnings. In 1991 a teacher by the name of Ken Campbell was leading a special needs classroom south of the swamp in central Florida. Born with a passion to help all children become “Simply better,” Ken grew frustrated as he observed how both classroom time and the tools provided were lacking. Like other great teachers before him, Ken sacrificed his own time and money to create and test solutions that would effectively help these children improve.</p>
                        <p class="indented">His efforts were successful right from the start. The real catalyst that made Great Leaps an internationally implemented program was a routine visit from a leading University of Florida Professor, Dr. Cecil Mercer. During the professors visit he overheard a student ask the principal to move an assembly time “so that it would not interfere with his reading lesson.” WOW!  This would get any teachers attention and the professor promptly asked for some copies of Ken's program for conducting trials at a High School in Gainesville, Florida. As history would have it, the trial was a huge success. Dr. Mercer then proudly presented the data and the initial program at the Learning Disabilities Association Conference in Chicago and positive reviews prompted to publish his science and Great Leaps was launched.</p>
                    </div>

                    <div class="col-md-4 vcenter">
                        <img
                            class="img-fluid center-block"
                            src={ken_office}
                            alt="A picture of Ken in his office"
                            title="He makes reading fun!"
                            style={{ "padding": "20px" }}
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12">
                        <p class="indented text-left">Today, Great Leaps is in all fifty states and in over forty countries. Proudly Ken’s gifts have helped over half a million children and growing simply because, it works. Today Great Leaps is unrolling “Great Leaps Digital,” which integrates decades of experience and wisdom with 21st century technology making the tools faster more accessible, and more effective than ever before!</p>
                    </div>
                </div>

                <h2 class="section-header text-left">About the Author</h2>
                <p class="text-justify indented">Ken Campbell's 36 year teaching career and his extensive study of accomplished academic researchers certainly adds credibility to the highly effective Great Leaps Programs, but his passion to help children is really the driving force behind the company and its growth. Although he will always be a teacher at heart, there came a time where Great Leaps allowed his impact on students to grow beyond teaching one classroom at a time. So the accidental entrepreneur was born.</p>

                <div class="row">
                    <div class="col-md-6 vcenter">
                        <img
                            class="img-fluid center-block"
                            width="auto"
                            height="auto"
                            src={ken_classroom}
                            alt="A picture of Ken in a classroom"
                            title="He makes reading fun!"
                            style={{ "padding": "20px" }}
                        />
                    </div>

                    <div class="col-md-6 text-justify vcenter">
                        <p class="indented">When he's not in the office Ken enjoys a deep connection with family history through his study of Scotland and his ancestors. Once fall comes around, you can catch him cheering on his alma mater, the University of Florida, clad in orange and blue. Ken continues to write short stories and novels in his free time but most importantly, he enjoys spending time with his wife Diana, three kids, and 6 grandkids either on the beaches of St. Augustine or simply relaxing at home. He is a strong believer in the power of community and developed Great Leaps to be easy enough for virtually anyone to teach a child to read and leave a lasting impact on their life.</p>
                    </div>
                </div>
            </div>

        </React.Fragment>
    )
}

export default Story;
